let subscribers = {}

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = []
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback
    });
  }
};

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data)
    })
  }
}

///newsletter button class add start
document.addEventListener('DOMContentLoaded', function () {
    const newsletterForms = document.querySelectorAll('.newsletter-form'); // Select all newsletter forms

    newsletterForms.forEach((newsletterForm) => {
        const submitButton = newsletterForm.querySelector('button[type="submit"]'); // Find the submit button within each form

        if (submitButton) {
            submitButton.addEventListener('click', function (event) {
                const emailInput = newsletterForm.querySelector('input[type="email"]');
                const emailValue = emailInput.value.trim();
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple email regex pattern
  
                if (!emailValue) {
                    return;
                }
  
                if (!emailPattern.test(emailValue)) {
                    return;
                }
  
                // Add a loading state if email is valid
                submitButton.classList.add('is-loading');
                newsletterForm.classList.add('is-loading');
            });

            // Add a submit event listener to the form
            newsletterForm.addEventListener('submit', function (event) {
                // Optionally, check if the form submission is valid
                if (!newsletterForm.checkValidity()) {
                    event.preventDefault(); // Prevent submission if the form is invalid
                    submitButton.classList.remove('is-loading'); // Remove the class if invalid
                    newsletterForm.classList.remove('is-loading');
                }
                // The class will persist during valid submission
            });
        }
    });
});

///newsletter button class add end